import { jsx } from "react/jsx-runtime";
import { useState, useRef, useLayoutEffect } from "react";
import styled from "styled-components";
import useResizeObserver from "use-resize-observer";
import { Tooltip } from "./Tooltip.js";
import { InputWrapper } from "./Input.styles.js";
function TruncatedText({
  children,
  tooltipPosition = "top-left",
  ...props
}) {
  const [isTruncated, setIsTruncated] = useState(false);
  const text = useRef(null);
  function checkTruncation() {
    if (text.current) {
      const result = text.current.offsetWidth < text.current.scrollWidth;
      setIsTruncated(result);
    }
  }
  useResizeObserver({
    ref: text,
    onResize: () => {
      checkTruncation();
    }
  });
  useLayoutEffect(() => {
    checkTruncation();
  }, []);
  return /* @__PURE__ */ jsx(StyledText, {
    ref: text,
    ...props,
    children: isTruncated ? /* @__PURE__ */ jsx(Tooltip, {
      content: children,
      position: tooltipPosition,
      timing: "delay",
      children: (triggerProps) => /* @__PURE__ */ jsx("span", {
        ...triggerProps,
        children
      })
    }) : children
  });
}
const StyledText = styled.span.withConfig({
  displayName: "StyledText",
  componentId: "sc-b6pp4c-0"
})(["display:block;overflow:hidden;min-width:0;text-decoration:none;text-overflow:ellipsis;white-space:nowrap;&::after{content:'';display:block;}&:has(", "){overflow:visible;}"], InputWrapper);
export {
  TruncatedText
};
//# sourceMappingURL=TruncatedText.js.map
